import i18n from "../i18n";
import ThemeSwitcher from "../Optime/ThemeSwitcher/ThemeSwitcher";

const ThemeColor = ThemeSwitcher(true);

// Roles status
// 0 => hide
// 1 => disabled
// 2 => show

export const TOOLS = {
  // value -> send to backend as algorithm tool
  "REVERSE LOGISTIC": "FULL_REVERSE_LOGISTIC",
  "FORWARD LOGISTIC": "FULL_FORWARD_LOGISTIC",
  "EQUAL DISTANCE": "TOOL.EQUAL_DISTANCE_DISPATCH",
  "CVRP TW PD": "TOOL.CVRP_TW_PD",
  "LIVE TRACK": "TOOL.LIVE_TRACK",
  "MULTI DEPOT VRP": "TOOL.MULTI_DEPOT_VRP",
  "LARGE ITEMS": "TOOL.LARGE_ITEM",
  "CUSTOM CLUSTERING": "TOOL.STATIC_CLUSTERING",
};

export const D_D = {
  DRIVER: "driver",
  DISTRIBUTOR: "distributor",
};

export const MENU_ITEMS = [
  {
    title: "Driver Management",
    path: "/driver-management",
    icon: "user",
    tooltip: "Driver_Management",
    storage: ["driver_mng_table_page", "driver_mng_table_row"],
  },
  {
    title: "Plans",
    path: "/planning",
    icon: "task",
    tooltip: "Plans",
    storage: ["planing_table_page", "planing_table_row"],
  },
  {
    title: "MicroHub",
    path: "/microhub",
    icon: "home",
    tooltip: "Micro Hub",
    storage: ["MicroHub_table_page", "MicroHub_table_row"],
  },
  // { title: "Plan View", path: "/map", icon: "public", tooltip: "Plan view" },
  {
    title: "Driver Log",
    path: "/driver-log",
    icon: "table",
    tooltip: "Driver_Log",
    storage: ["driver_log_table_page", "driver_log_table_row"],
  },
  {
    title: "Analytics",
    path: "/analytics",
    icon: "analytics",
    tooltip: "Analytics",
    storage: ["driver_log_table_page", "driver_log_table_row"],
  },
];

export const PLAN_VIEW_DRAWER_TAB = [
  {
    title: "Remain Pins",
    icon: "remainPin",
    id: 1,
    tooltip: "Remain",
    showHelper: true,
  },
  { title: "Pin", icon: "pin", id: 2, tooltip: "PinInfo" },
  { title: "Polygon", icon: "polygon", id: 3, tooltip: "PolyInfo" },
  {
    title: "Not Met Pin",
    icon: "notmet",
    id: 4,
    tooltip: "NotMet",
    showHelper: true,
  },
  {
    title: "Deleted Pins",
    icon: "trash",
    id: 5,
    tooltip: "Deleted",
    showHelper: true,
  },
];

export const LIVE_TRACK_DRAWER_TAB = [
  { title: "Drivers List", icon: "users", id: 1 },
  { title: "Driver Info", icon: "user", id: 2 },
];

export const MENU_SEARCH_ITEMS = {
  ORDER_ID: "ORDER_ID",
  CUSTOMER_NAME: "CUSTOMER_NAME",
  ADDRESS: "ADDRESS",
  PHONE_NUMBER: "PHONE_NUMBER",
  DESCRIPTION: "DESCRIPTION",
  DRIVER_NAME: "DRIVER_NAME",
  DISTRIBUTOR: "DISTRIBUTOR",
};

export const LIVETRCK_SEARCH_ITEMS = {
  ORDER_ID: i18n.t("MenuSearch.ORDER_ID"),
  CUSTOMER_NAME: i18n.t("MenuSearch.CUSTOMER_NAME"),
  ADDRESS: i18n.t("MenuSearch.ADDRESS"),
  PHONE_NUMBER: i18n.t("MenuSearch.PHONE_NUMBER"),
  DISTRIBUTOR: i18n.t("MenuSearch.DISTRIBUTOR"),
};

export const SORT_POLYGONS_LIST = {
  DEFAULT: "Default",
  PINS: "Total pins",
  PACKETS: "Total packets",
  DISTANCE: "Distance",
  DURATION: "Duration",
};

export const SEARCH_POLYGON_PIN_BY = {
  ADDRESS: "Address",
  ORDER_ID: "Order ID",
  RECIPIENT_NAME: "Customer Name",
};

export const SEARCH_LIVE_TRACK_DRIVERS_BY = {
  DRIVER_NAME: "Driver Name",
  PHONE_NUMBER: "Phone Number",
};

export const SORT_LIVE_TRACK_DRIVERS_BY = {
  ACTIVE_DRIVERS: "Active Drivers",
  STEPS_LEFT: "Steps Left",
  TOTAL_MISSIONS: "Total Missions",
  GPS_SIGNAL: "GPS Signal",
  MOBILE_LOCATION: "Driver Mobile GPS",
};

export const DRIVER_TOOLS_ZONE_PERMITION = {
  NONE: 3,
  "FULL TRAFIC ZONE": 2,
  "AIR POLUTION ZONE": 1,
};

export const WeightCapacityUnits = {
  1: "KG",
  2: "TON",
};

export const VolumeCapacityUnits = {
  1: "LITER",
  2: "M3",
};

export const MENUE_ITEMS = [
  { title: "Driver Management", path: "/driver-management", icon: "user" },
  { title: "Plans", path: "/planning", icon: "task" },
  { title: "Plan View", path: "/map", icon: "public" },
  { title: "Drivers Log", path: "/driver-log", icon: "table" },
  // { title: "Analytics", path: "/analytics", icon: "analitics" },
  // { title: "Vehicles", path: "/vehicles", icon: "truck" },
];

export const MISSION_STATUS = {
  start: "Started",
  waiting: "Waiting",
  completed: "Completed",
  rejected: "Rejected",
  halfDelivered: "Half Delivered",
  noReceiver: "No Receiver",
  pickedUpPacket: "Scanned",
};

export const MISSION_STATUS_WITH_TOTAL = {
  total: "Total missions",
  start: "Started",
  waiting: "Waiting",
  completed: "Successful",
  canceled: "Canceled",
  rejected: "Rejected",
  halfDelivered: "Half Delivered",
  noReceiver: "No Receiver",
  pickedUpPacket: "Scanned",
};

export const MISSION_STATUS_WITH_TOTAL_UPPERCASE = {
  total: "TOTAL",
  Remaining: "ASSIGN",
  start: "START",
  waiting: "WAITING",
  completed: "COMPLETED",
  canceled: "CANCELED",
  rejected: "REJECTED",
  halfDelivered: "HALFDELIVERED",
  noReceiver: "NORECEIVER",
  pickedUpPacket: "SCANNED",
  // pending: "PENDING",
};

export const ColorsMap = {
  start: ThemeColor[13],
  waiting: ThemeColor[12],
  completed: ThemeColor[10],
  rejected: ThemeColor[9],
  halfDelivered: ThemeColor[11],
  noReceiver: ThemeColor[14],
  total: ThemeColor[2],
  pending: ThemeColor[15],
  canceled: ThemeColor[16],
  Remaining: ThemeColor[7],
  Started: ThemeColor[13],
  Waiting: ThemeColor[12],
  Complete: ThemeColor[10],
  Completed: ThemeColor[10],
  "No Receiver": ThemeColor[14],
  "Half Delivered": ThemeColor[11],
  Rejected: ThemeColor[9],
  pickedUpPacket: ThemeColor[15],
};

export const ALL_STATUS_FILTERS = {
  0: "Remaining",
  1: "start",
  2: "waiting",
  3: "completed",
  4: "canceled",
  5: "noReceiver",
  6: "halfDelivered",
  7: "rejected",
  8: "pending",
  10: "pickedUpPacket",
};

export const ALL_STATUS = {
  0: "Remaining",
  1: "Started",
  2: "Waiting",
  3: "Completed",
  4: "canceled",
  5: "No Receiver",
  6: "Half Delivered",
  7: "Rejected",
  10: "pickedUpPacket",
  // 8: "Pending",
};

export const PLAN_STATUS = {
  Optimized: 1,
  Config: 2,
  Failed: 3,
  Optimizing: 4,
  Warning: 5,
  Execute: 6,
  Processing: 7,
  ReOptimizing: 8,
  Preview: 12,
};

export const FILTER_DRIVER_BY_ACTIVATION = {
  NONE: "none",
  ACTIVE: "true",
  DEACTIVE: "false",
};

export const SERVERS = {
  // "Production (api2.optime)": "https://api2.optime-ai.com",
  "Demo (demo-api)": "http://91.108.142.245:5100",
  "Test (95.38.60.148:5000)": "http://95.38.60.148:5000",
  "Test-1 (95.38.60.148:5001)": "http://95.38.60.148:5001",
  "Test-2 (95.38.60.148:5002)": "http://95.38.60.148:5002",
};

export const BACK_SERVERS = {
  "Production (api2.optime)": "https://api2.optime-ai.com",
  "Demo (demo-api)": "http://91.108.142.245:5100",
  "Test (95.38.60.148:5000)": "http://95.38.60.148:5000",
  "Test-1 (95.38.60.148:5001)": "http://95.38.60.148:5001",
  "Test-2 (95.38.60.148:5002)": "http://95.38.60.148:5002",
};

export const ANALYTICS_INTERVAL = {
  DAY: "DAY",
  MONTH: "MONTH",
};

export const WEEK_DAY = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

export const DISTANCE_LINES = [
  {
    type: "monotone",
    key: "Average of Distance",
    color: ThemeColor[8],
    r: 6,
    showValueOnLine: true,
  },
];

export const DURATION_LINES = [
  {
    type: "monotone",
    key: "Average of Duration",
    color: ThemeColor[12],
    r: 6,
    showValueOnLine: true,
  },
];

export const STACK_BAR = [
  {
    key: "Completed",
    id: "same",
    color: "#33ff99",
  },
  {
    key: "Half Delivered",
    color: "#ffff99",
    id: "same",
  },
  {
    key: "No Receiver",
    color: "#ff8080",
    id: "same",
  },
  {
    key: "Rejected",
    color: "#ff4d4d",
    id: "same",
  },
  {
    key: "Remaining",
    color: "#00cccc",
    id: "same",
  },
];

export const COLORS_LIST = [
  "#ff3385",
  "#00e6e6",
  "#ef843c",
  "#ffff99",
  "#7eb26d",
  "#e60073",
  "#00cccc",
  "#8080ff",
  "#33ff99",
  "#ff8080",
  "#b3b300",
  "#ff33ff",
  "#ffffff",
  "#ff4d4d",
  "#508642",
  "#6ed0e0",
  "#eab839",
  "#bf4080",
  "#00b33c",
  "#7300e6",
  "#73a0e6",
  "#99a816",
  "#a47eff",
  "#a9a076",
  "#ca6ae7",
];

export const TIME_FILTER = [
  "Today",
  "Yesterday",
  "Last Week",
  "Last Month",
  "Last Year",
  "Select Date",
];

export const PROVINCES = {
  alborz: "Alborz",
  ardabil: "Ardabil",
  bushehr: "Bushehr",
  chaharmahalandbakhtiari: "Chaharmahal and Bakhtiari",
  eastazerbaijan: "East Azerbaijan",
  fars: "Fars",
  gilan: "Gilan",
  golestan: "Golestan",
  hamadan: "Hamadan",
  hormozgan: "Hormozgan",
  ilam: "Ilam",
  isfahan: "Isfahan",
  kerman: "Kerman",
  kermanshah: "Kermanshah",
  khuzestan: "Khuzestan",
  kohgiluyehandboyerahmad: "Kohgiluyeh and Boyer-Ahmad",
  kurdistan: "Kurdistan",
  lorestan: "Lorestan",
  markazi: "Markazi",
  mazandaran: "Mazandaran",
  northkhorasan: "North Khorasan",
  qazvin: "Qazvin",
  qom: "Qom",
  razavikhorasan: "Razavi Khorasan",
  semnan: "Semnan",
  sistanandbaluchestan: "Sistan and Baluchestan",
  tehran: "Tehran",
  westazerbaijan: "West Azerbaijan",
  yazd: "Yazd",
  zanjan: "Zanjan",
};

export const PROVINCES_CENTER = {
  qom: [34.644083001967005, 50.87923049926758],
  yazd: [31.87172661206501, 54.35022354125976],
  ilam: [33.63491667679363, 46.40719413757324],
  qazvin: [36.29015440311434, 50.0083065032959],
  zanjan: [36.67544081082709, 48.5115909576416],
  fars: [29.614356425026187, 52.524261474609375],
  gilan: [37.28060928450999, 49.592199325561516],
  semnan: [35.58351321440279, 53.38879108428955],
  alborz: [35.834689013731015, 50.95051288604736],
  isfahan: [32.6791180993732, 51.672134399414055],
  kerman: [30.291163169636707, 57.06770896911621],
  tehran: [35.711639291719464, 51.40708923339843],
  ardabil: [38.25162821893197, 48.29765796661377],
  golestan: [36.8416445052441, 54.43305015563965],
  bushehr: [28.968536888453823, 50.83687305450439],
  lorestan: [33.48657861929678, 48.35606575012207],
  markazi: [34.09595600596673, 49.701805114746094],
  hamadan: [34.798298899001196, 48.51489543914795],
  hormozgan: [27.19624340878391, 56.28776550292968],
  khuzestan: [31.302828396061393, 48.68471145629883],
  kurdistan: [35.311553247291386, 46.99625015258789],
  mazandaran: [36.563909881837766, 53.06319236755371],
  kermanshah: [34.329473930636794, 47.08070755004883],
  northkhorasan: [37.47220147534966, 57.32919216156006],
  southkhorasan: [32.87317166460953, 59.21630859374999],
  westazerbaijan: [37.55308350936187, 45.07596015930176],
  eastazerbaijan: [38.07414281009269, 46.29630088806152],
  razavikhorasan: [36.297833239417564, 59.607009887695305],
  sistanandbaluchestan: [29.48862024048175, 60.863485336303704],
  chaharmahalandbakhtiari: [32.33225353369601, 50.856571197509766],
  kohgiluyehandboyerahmad: [30.667299525791496, 51.58003807067871],
};

export const ORGANIZATION_TAB = {
  // ORG_INFO: "Info",
  TENANTS: "Tenants",
  // ACCOUNT: "Account",
  // WALLET: "Wallet",
  ORG_USAGE: "Usage",
  ORG_CONFIG: "Configuration",
};

export const ORGANIZATION_ADMIN_TAB = {
  ORGS: "Organizations",
  ADMIN_USAGE: "Usage",
};

export const SUPERADMIN_ORGANIZATION_TAB = {
  ORG_INFO: "Info",
  TENANTS: "Tenants",
  // ACCOUNT: "Account",
  // WALLET: "Wallet",
  ORG_USAGE: "Usage",
  ORG_CONFIG: "Configuration",
};

export const ADMIN_ORGANIZATION_TAB = {
  ORG_INFO: "Info",
  TENANTS: "Tenants",
  ORG_USAGE: "Usage",
  ORG_CONFIG: "Configuration",
};

export const ORGANIZATIONS_TAB = {
  ORGS: "Organizations",
  // USAGE: "Usage",
  // ADMINS: "Admins",
  // USERS: "Users",
  PLANS: "Plans",
  // UMS: "UserManagement",
  CONTRACT_DETAILS: "ContractDetails",
  UPLOAD_APP: "UploadApp",
};

export const TENANT_TAB = {
  TENANT_INFO: "Info",
  // USAGE: "Usage",
  USERS: "Users",
  TENANT_CONFIG: "Tenant Config",
};

export const VEHICLES = {
  1: "motor",
  2: "car",
  3: "van",
  4: "truck",
};

export const EXCEL_REQUIRED_COLUMN_TYPE = [
  "Id",
  "Address",
  "Latitude",
  "Longitude",
];

export const EXCEL_COLUMN_TYPE = {
  Id: "Id",
  Address: "Address",
  Latitude: "Latitude",
  Longitude: "Longitude",
  Weight: "Weight",
  Volume: "Volume",
};

export const TABLE_SEARCH_TYPE = {
  TEXT: "text",
  SELECT: "select",
  DATE: "date",
};

export const CVRP_TYPE = {
  Cvrp1: 1,
  Cvrp2: 2,
  Cvrp3: 3,
};

export const MissionInformationStatus = {
  0: "ASSIGN",
  1: "START",
  2: "WAITING",
  3: "COMPLETED",
  4: "CANCELED",
  5: "NORECEIVER",
  6: "HALFDELIVERED",
  7: "REJECTED",
  8: "PENDING",
  9: "CATCHED_BY_DRIVE",
  10: "SCANNED",
};

export const TIME_ZONE = {
  IRAN: "iran",
};

export const TIME_ZONE_DATE = {
  "Asia/Dubai": "Asia/Dubai",
  "Asia/Tehran": "Asia/Tehran",
};

export const APP_SAVE_GALLERY = {
  Save_In_Gallery: 0,
  Dont_Save_In_Gallery: 1,
  Ask_User_In_App: 2,
};
